// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__4f8dd","EventsList":"styles_EventsList__6T-eP"};